import { render } from "./New.vue?vue&type=template&id=066e84d2&scoped=true&ts=true"
import script from "./New.vue?vue&type=script&lang=ts"
export * from "./New.vue?vue&type=script&lang=ts"

import "./New.vue?vue&type=style&index=0&id=066e84d2&scoped=true&lang=scss"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066e84d2"]])

export default __exports__